import { User } from "@/types/user";

export const setupHelper = {
  isDoneAccountConfig(user?: User): boolean {
    return !!user?.gmtTimeZone
  }
}